export default "__VITE_ASSET__BqTVeAyC__"